var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArmchairMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.4066H16.5",
    stroke: "#5A5B5D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.65662V7.40662C4.5 6.61097 4.81607 5.8479 5.37868 5.2853C5.94129 4.72269 6.70435 4.40662 7.5 4.40662H16.5C17.2956 4.40662 18.0587 4.72269 18.6213 5.2853C19.1839 5.8479 19.5 6.61097 19.5 7.40662V9.65662",
    stroke: "#5A5B5D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.4066V12.6566C7.5 12.0633 7.32405 11.4833 6.99441 10.9899C6.66477 10.4966 6.19623 10.112 5.64805 9.88498C5.09987 9.65792 4.49667 9.59851 3.91473 9.71426C3.33279 9.83002 2.79824 10.1157 2.37868 10.5353C1.95912 10.9549 1.6734 11.4894 1.55765 12.0713C1.44189 12.6533 1.5013 13.2565 1.72836 13.8047C1.95543 14.3528 2.33994 14.8214 2.83329 15.151C3.32664 15.4807 3.90666 15.6566 4.5 15.6566V19.4066C4.5 19.6055 4.57902 19.7963 4.71967 19.9369C4.86032 20.0776 5.05109 20.1566 5.25 20.1566H18.75C18.9489 20.1566 19.1397 20.0776 19.2803 19.9369C19.421 19.7963 19.5 19.6055 19.5 19.4066V15.6566C20.0933 15.6566 20.6734 15.4807 21.1667 15.151C21.6601 14.8214 22.0446 14.3528 22.2716 13.8047C22.4987 13.2565 22.5581 12.6533 22.4424 12.0713C22.3266 11.4894 22.0409 10.9549 21.6213 10.5353C21.2018 10.1157 20.6672 9.83002 20.0853 9.71426C19.5033 9.59851 18.9001 9.65792 18.352 9.88498C17.8038 10.112 17.3352 10.4966 17.0056 10.9899C16.6759 11.4833 16.5 12.0633 16.5 12.6566V16.4066",
    stroke: "#5A5B5D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmchairMenu);
export default __webpack_public_path__ + "static/media/armchair-menu.ffd7afd2ca91fe76b4129965fdb26cf4.svg";
export { ForwardRef as ReactComponent };